import { KanbanBoard, UnifiedKanbanCard } from "@/components/ui";

export const ProjectKanban = ({ stages, filtered, onProjectClick, updateStatus, onUpdateProject, teamMembers = [] }) => {
  const onItemMove = (project, stageKey) => {
    updateStatus(project, stageKey);
  };

  return (
    <KanbanBoard
      className="bg-slate-50/30"
      stages={stages}
      items={filtered}
      onItemMove={onItemMove}
      renderCard={(project) => (
        <UnifiedKanbanCard 
          item={project} 
          onClick={onProjectClick}
          onUpdate={onUpdateProject}
          teamMembers={teamMembers}
          variant="project"
        />
      )}
    />
  );
};
